import { Close } from '@wix/wix-ui-icons-common/on-stage';
import { useTranslation } from '@wix/yoshi-flow-editor';
import type { FC } from 'react';
import React, { useEffect, useRef } from 'react';
import { IconButton } from '@wix/wix-ui-tpa/cssVars';

import { useWidget } from '../../../../../../../contexts/widgets';
import { absorbArguments } from '../../../../../../../services/event-handler';
import { DataHook } from '../../../../../../../types';
import { CustomButton } from '../../common';
import styles from './CoverRepositionButtons.scss';

export const CoverRepositionButtons: FC = () => {
  const { t } = useTranslation();
  const { handlers } = useWidget();
  const { leaveCoverRepositionMode, saveCoverReposition } = handlers;

  const cardCoverCancelRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    cardCoverCancelRef.current?.focus();
  }, []);

  const handleCoverRepositionCancel = absorbArguments(leaveCoverRepositionMode);
  const handleCoverRepositionSave = absorbArguments(saveCoverReposition);

  return (
    <div className={styles.repositionModeButtons}>
      <div className={styles.buttonsBox}>
        <IconButton
          icon={<Close />}
          onClick={handleCoverRepositionCancel}
          data-hook={DataHook.CardCoverCancel}
          className={styles.cancelButton}
          innerRef={cardCoverCancelRef}
          aria-label={t('profile-widget.close.aria-label')}
        />
        <CustomButton
          title={t('profile-widget.done')}
          dataHook={DataHook.CardCoverSave}
          className={styles.truncateText}
          onClick={handleCoverRepositionSave}
          isSecondary={true}
        />
      </div>
    </div>
  );
};
